import Overview from './Overview'
import Settings from './Settings'
import AllModals from './AllModals'

export default {
  Overview,
  Settings,
  AllModals
}